import { render, staticRenderFns } from "./Construction.vue?vue&type=template&id=f62f6b92&scoped=true"
import script from "./Construction.vue?vue&type=script&lang=js"
export * from "./Construction.vue?vue&type=script&lang=js"
import style0 from "./Construction.vue?vue&type=style&index=0&id=f62f6b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f6b92",
  null
  
)

export default component.exports